import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { t } from '@lingui/macro';
import { isValidMarketRegion } from '../../../../helpers/utils';

import ThreeEssentailsButton from '../../../three-essentails-button/three-essentails-button';
import Resources from '../../../../helpers/resources';
import ImageAsset from '../../../image-asset/image-asset';

const OneRosterManageStudents = ({
    i18n,
    title
}) => {
    const [moduleLink, setModuleLink] = useState('');
    useEffect(() => {
        Resources.getConfigurationItem('THREE_ESSENTIALS_REMOVE_STUDENT')
            .then(manageStudentsUrl => setModuleLink(manageStudentsUrl));
    });

    return (
        <div className="modal__manage_students_container">
            <div>
                <ImageAsset type={'manageStudents'} />
            </div>
            <div className="modal__manage_students_container__manage_students">
                <h1>{title}</h1>
                <span>{i18n._(t`OneRoster - Manage students`)}</span>
                <ThreeEssentailsButton
                    show3EIcon={isValidMarketRegion()}
                    buttonClassName={'modal_manage'}
                    clickHandler={() => window.open(moduleLink)}
                    title={i18n._(t`OneRoster - manage`)} />
            </div>
        </div>
    );
};

OneRosterManageStudents.propTypes = {
    i18n: PropTypes.object,
    title: PropTypes.string
};

export default OneRosterManageStudents;



// WEBPACK FOOTER //
// ./components/generic-modal/components/one-roster-manage-students/one-roster-manage-students.js